/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from './home.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../src/app/home/home.component';
import * as import3 from '../../../../src/app/shared/services/auth.service';
const styles_HomeComponent:any[] = [import0.styles];
export const RenderType_HomeComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_HomeComponent,
  data: {}
}
);
export function View_HomeComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'id',
        'initial-load'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_HomeComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'my-home',([] as any[]),(null as any),(null as any),(null as any),View_HomeComponent_0,RenderType_HomeComponent)),
    import1.ɵdid(57344,(null as any),0,import2.HomeComponent,[import3.AuthService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const HomeComponentNgFactory:import1.ComponentFactory<import2.HomeComponent> = import1.ɵccf('my-home',import2.HomeComponent,View_HomeComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3RtcC9zd2lmdC1idWlsZC9wcm9kL3NyYy9hcHAvaG9tZS9ob21lLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9zcmMvYXBwL2hvbWUvaG9tZS5jb21wb25lbnQudHMiLCJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9zcmMvYXBwL2hvbWUvaG9tZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL3NyYy9hcHAvaG9tZS9ob21lLmNvbXBvbmVudC50cy5Ib21lQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBpZD1cImluaXRpYWwtbG9hZFwiPjwvZGl2PlxuIiwiPG15LWhvbWU+PC9teS1ob21lPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0FBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNkI7Ozs7OztJQ0E3QjtnQkFBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/src/app/home/home.component.ngfactory.ts